import { render, staticRenderFns } from "./AddEmailNotificaton.vue?vue&type=template&id=0a13f4b1&"
import script from "./AddEmailNotificaton.vue?vue&type=script&lang=js&"
export * from "./AddEmailNotificaton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports